import { SVGProps } from 'react';

export const TeamIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4 12.9479V10.3999H8.8V8.7999H12.2336L11.9744 7.7991C11.6008 6.3567 10.468 5.2823 9.0776 4.9327C9.8584 4.5359 10.4 3.7343 10.4 2.7999C10.4 1.4767 9.3232 0.399902 8 0.399902C6.6768 0.399902 5.6 1.4767 5.6 2.7999C5.6 3.7343 6.1416 4.5359 6.9224 4.9327C5.532 5.2823 4.3992 6.3567 4.0256 7.7991L3.7664 8.7999H7.2V10.3999H1.6V12.9479C0.6704 13.2791 0 14.1591 0 15.1999C0 16.5239 1.0768 17.5999 2.4 17.5999C3.7232 17.5999 4.8 16.5239 4.8 15.1999C4.8 14.1591 4.1296 13.2791 3.2 12.9479V11.9999H7.2V12.9479C6.2704 13.2791 5.6 14.1591 5.6 15.1999C5.6 16.5239 6.6768 17.5999 8 17.5999C9.3232 17.5999 10.4 16.5239 10.4 15.1999C10.4 14.1591 9.7296 13.2791 8.8 12.9479V11.9999H12.8V12.9479C11.8704 13.2791 11.2 14.1591 11.2 15.1999C11.2 16.5239 12.2768 17.5999 13.6 17.5999C14.9232 17.5999 16 16.5239 16 15.1999C16 14.1591 15.3296 13.2791 14.4 12.9479Z"
        fill="currentColor"
      />
    </svg>
  );
};
